"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkRetrieveHashedUinfin = exports.FindOrCreateUser = exports.UpsertMobileOtpData = exports.GetMobileOtpData = exports.UpsertSsoUsersData = exports.GetSsoUserData = exports.CreateSsoUser = exports.GetUnifiedUserProfile = exports.GetUserIdsByPostals = exports.GetGuestUser = exports.UpdateUserIdentifierData = exports.UpsertWogUsersData = exports.GetUserIdentifierData = exports.GetWogUserDataByIdentifiers = exports.GetWogUserData = exports.CreateWogUser = exports.CreateUserIdentifier = exports.GetWogUserProfile = exports.GetHashUinfinsFromUserIds = exports.GetHashedUinfinUserIdMapping = exports.GetMyHashedUinfin = exports.GetHashedUinfin = exports.GetUinfinUserIdMapping = exports.RefreshPersonSensitiveData = exports.SavePersonSensitiveData = exports.GetPersonSensitiveData = exports.GetInfoPreferencesV2 = exports.GetPersonData = exports.SavePersonData = exports.GetPersonInfoWithUpdatedAt = exports.GetPersonInfoPreferences = exports.SavePersonPreferenceData = exports.GetPersonPreferenceData = exports.GetPersonUserId = void 0;
const bulkRetrieveHashedUinfinApiDomain = __importStar(require("./bulk-retrieve-hashed-uinfin/bulk-retrieve-hashed-uinfin-api-domain"));
const bulkRetrieveHashedUinfinTransformer = __importStar(require("./bulk-retrieve-hashed-uinfin/transformer/bulk-retrieve-hashed-uinfin-api-domain-transformer"));
const findOrCreateUserApiDomain = __importStar(require("./find-or-create-user/find-or-create-user-api-domain"));
const getGuestUserApiDomain = __importStar(require("./get-guest-user/get-guest-user-api-domain"));
const getHashedUinfinUserIdMappingDomain = __importStar(require("./get-hashed-uinfin-user-id-mapping/get-hashed-uinfin-user-id-mapping-api-domain"));
const getHashedUinfinUserIdMappingTransformer = __importStar(require("./get-hashed-uinfin-user-id-mapping/transformer/get-hashed-uinfin-user-id-mapping-api-domain-transformer"));
const getHashedUinfinDomain = __importStar(require("./get-hashed-uinfin/get-hashed-uinfin-api-domain"));
const getMyHashedUinfinDomain = __importStar(require("./get-hashed-uinfin/get-hashed-uinfin-api-domain"));
const getHashedUinfinTransformer = __importStar(require("./get-hashed-uinfin/transformer/get-hashed-uinfin-api-domain-transformer"));
const getHashedUinfinsFromUserIdsDomain = __importStar(require("./get-hashuinfins-from-userids/get-hashuinfins-from-userids-api-domain"));
const getHashedUinfinsFromUserIdsTransformer = __importStar(require("./get-hashuinfins-from-userids/transformer/get-hashuinfins-from-userids-api-domain-transformer"));
const getInfoPreferencesV2Domain = __importStar(require("./get-info-preferences-v2/get-info-preferences-v2-api-domain"));
const getInfoPreferencesV2Transformer = __importStar(require("./get-info-preferences-v2/transformer"));
const getInfoPreferencesDomain = __importStar(require("./get-info-preferences/get-info-preferences-api-domain"));
const getInfoPreferencesTransformer = __importStar(require("./get-info-preferences/transformer/get-info-preferences-api-domain-transformer"));
const getInfoWithUpdatedAtDomain = __importStar(require("./get-info-with-updated-at/get-info-with-updated-at-api-domain"));
const getInfoWithUpdatedAtTransformer = __importStar(require("./get-info-with-updated-at/transformer/get-info-with-updated-at-api-domain-transformer"));
const getMyHashedUinfinTransformer = __importStar(require("./get-my-hashed-uinfin/transformer/get-my-hashed-uinfin-api-domain-transformer"));
const GetPersonDataDomain = __importStar(require("./get-person-data/get-person-data-api-domain"));
const GetPersonDataTransformer = __importStar(require("./get-person-data/transformer"));
const getSenstivePersonDataDomain = __importStar(require("./get-person-sensitive-data/get-person-sensitive-data-api-domain"));
const getSenstivePersonDataTransformer = __importStar(require("./get-person-sensitive-data/transformer/get-person-sensitive-data-api-domain-transformer"));
const getPreferencesDomain = __importStar(require("./get-preferences/get-preferences-api-domain"));
const getPreferencesTransformer = __importStar(require("./get-preferences/transformer/get-preferences-api-domain-transformer"));
const getUinfinUserIdMappingDomain = __importStar(require("./get-uinfin-user-id-mapping/get-uinfin-user-id-mapping-api-domain"));
const getUinfinUserIdMappingTransformer = __importStar(require("./get-uinfin-user-id-mapping/transformer/get-uinfin-user-id-mapping-api-domain-transformer"));
const getUnifiedUserApiDomain = __importStar(require("./get-unified-user/get-unified-user-api-domain"));
const getUserIdsByPostals = __importStar(require("./get-user-ids-by-postals/get-user-ids-by-postals-api-domain"));
const getUserIdsByPostalsTransformer = __importStar(require("./get-user-ids-by-postals/transformer/get-user-ids-by-postals-api-domain-transformer"));
const getMobileOtpApiDomain = __importStar(require("./mobile-otp/get-mobile-otp/get-mobile-otp-api-domain"));
const upsertMobileOtpTransformer = __importStar(require("./mobile-otp/upsert-mobile-otp/transformer/upsert-mobile-otp-api-domain-transformer"));
const upsertMobileOtpApiDomain = __importStar(require("./mobile-otp/upsert-mobile-otp/upsert-mobile-otp-api-domain"));
const refreshSenstivePersonDataDomain = __importStar(require("./refresh-person-sensitive-data/refresh-person-sensitive-data-api-domain"));
const refreshSenstivePersonDataTransformer = __importStar(require("./refresh-person-sensitive-data/transformer/refresh-person-sensitive-data-api-domain-transformer"));
const savePersonDataDomain = __importStar(require("./save-person-data/save-person-data-api-domain"));
const savePersonDataTransformer = __importStar(require("./save-person-data/transformer"));
const saveSenstivePersonDataDomain = __importStar(require("./save-person-senstive-data/save-person-sensitive-data-api-domain"));
const saveSenstivePersonDataTransformer = __importStar(require("./save-person-senstive-data/transformer/save-person-sensitive-data-api-domain-transformer"));
const savePreferencesDomain = __importStar(require("./save-preferences/save-preferences-api-domain"));
const savePreferencesTransformer = __importStar(require("./save-preferences/transformer/save-preferences-api-domain-transformer"));
const createSsoUserApiDomain = __importStar(require("./sso-user/create-sso-user/create-sso-user-api-domain"));
const createSsoUserTransformer = __importStar(require("./sso-user/create-sso-user/transformer/create-sso-user-api-domain-transformer"));
const getSsoUserApiDomain = __importStar(require("./sso-user/get-sso-user/get-sso-user-api-domain"));
const getSsoUserTransformer = __importStar(require("./sso-user/get-sso-user/transformer/get-sso-user-api-domain-transformer"));
const upsertSsoUserTransformer = __importStar(require("./sso-user/upsert-sso-user/transformer/upsert-sso-user-api-domain-transformer"));
const upsertSsoUserApiDomain = __importStar(require("./sso-user/upsert-sso-user/upsert-sso-user-api-domain"));
const createUserIdentifierApiDomain = __importStar(require("./wog-user/create-user-identifier/create-user-identifier-api-domain"));
const createUserIdentifierTransformer = __importStar(require("./wog-user/create-user-identifier/transformer/create-user-identifier-api-domain-transformer"));
const createWogUserApiDomain = __importStar(require("./wog-user/create-wog-user/create-wog-user-api-domain"));
const createWogUserTransformer = __importStar(require("./wog-user/create-wog-user/transformer/create-wog-user-api-domain-transformer"));
const getWogUserProfileApiDomain = __importStar(require("./wog-user/get-profile/get-user-profile-api-domain"));
const getWogUserProfileTransformer = __importStar(require("./wog-user/get-profile/transformer/get-user-profile-api-domain-transformer"));
const getUserIdentifierApiDomain = __importStar(require("./wog-user/get-user-identifier/get-user-identifier-api-domain"));
const getUserIdentifierTransformer = __importStar(require("./wog-user/get-user-identifier/transformer/get-user-identifier-api-domain-transformer"));
const getWogUserApiDomain = __importStar(require("./wog-user/get-wog-user/get-wog-user-api-domain"));
const getWogUserTransformer = __importStar(require("./wog-user/get-wog-user/transformer/get-wog-user-api-domain-transformer"));
const getWogUsersByIdentifierApiDomain = __importStar(require("./wog-user/get-wog-users-by-identifiers/get-wog-users-by-identifiers-api-domain"));
const getWogUsersByIdentifierTransformer = __importStar(require("./wog-user/get-wog-users-by-identifiers/transformer/get-wog-users-by-identifiers-api-domain-transformer"));
const updateUserIdentifierTransformer = __importStar(require("./wog-user/update-user-identifier/transformer/update-user-identifier-api-domain-transformer"));
const updateUserIdentifierApiDomain = __importStar(require("./wog-user/update-user-identifier/update-user-identifier-api-domain"));
const upsertWogUserTransformer = __importStar(require("./wog-user/upsert-wog-user/transformer/upsert-wog-user-api-domain-transformer"));
const upsertWogUserApiDomain = __importStar(require("./wog-user/upsert-wog-user/upsert-wog-user-api-domain"));
// =============================================================================
// Re-export
// =============================================================================
__exportStar(require("./common/api-domain"), exports);
__exportStar(require("./common/error"), exports);
__exportStar(require("./common/hashed-uinfin-agency"), exports);
__exportStar(require("./common/types"), exports);
__exportStar(require("./feature-announcement"), exports);
var GetPersonUserId;
(function (GetPersonUserId) {
    GetPersonUserId.method = "GET";
    GetPersonUserId.route = "myinfo/api/v1/getUserId";
})(GetPersonUserId || (exports.GetPersonUserId = GetPersonUserId = {}));
var GetPersonPreferenceData;
(function (GetPersonPreferenceData) {
    GetPersonPreferenceData.method = "GET";
    GetPersonPreferenceData.route = "myinfo/api/v1/user-preference";
    GetPersonPreferenceData.Domain = getPreferencesDomain;
    GetPersonPreferenceData.Transformers = getPreferencesTransformer;
})(GetPersonPreferenceData || (exports.GetPersonPreferenceData = GetPersonPreferenceData = {}));
var SavePersonPreferenceData;
(function (SavePersonPreferenceData) {
    SavePersonPreferenceData.method = "PUT";
    SavePersonPreferenceData.route = "myinfo/api/v1/user-preference";
    SavePersonPreferenceData.Domain = savePreferencesDomain;
    SavePersonPreferenceData.Transformers = savePreferencesTransformer;
})(SavePersonPreferenceData || (exports.SavePersonPreferenceData = SavePersonPreferenceData = {}));
var GetPersonInfoPreferences;
(function (GetPersonInfoPreferences) {
    GetPersonInfoPreferences.method = "GET";
    GetPersonInfoPreferences.route = "myinfo/api/v1/info-preferences";
    GetPersonInfoPreferences.Domain = getInfoPreferencesDomain;
    GetPersonInfoPreferences.Transformers = getInfoPreferencesTransformer;
})(GetPersonInfoPreferences || (exports.GetPersonInfoPreferences = GetPersonInfoPreferences = {}));
var GetPersonInfoWithUpdatedAt;
(function (GetPersonInfoWithUpdatedAt) {
    GetPersonInfoWithUpdatedAt.method = "GET";
    GetPersonInfoWithUpdatedAt.route = "myinfo/api/v2/me";
    GetPersonInfoWithUpdatedAt.Domain = getInfoWithUpdatedAtDomain;
    GetPersonInfoWithUpdatedAt.Transformers = getInfoWithUpdatedAtTransformer;
})(GetPersonInfoWithUpdatedAt || (exports.GetPersonInfoWithUpdatedAt = GetPersonInfoWithUpdatedAt = {}));
var SavePersonData;
(function (SavePersonData) {
    SavePersonData.method = "POST";
    SavePersonData.route = "myinfo/api/v2/save";
    SavePersonData.Domain = savePersonDataDomain;
    SavePersonData.Transformers = savePersonDataTransformer;
})(SavePersonData || (exports.SavePersonData = SavePersonData = {}));
var GetPersonData;
(function (GetPersonData) {
    GetPersonData.USER = {
        method: "GET",
        route: "myinfo/api/v3/me",
    };
    GetPersonData.SYSTEM = {
        method: "GET",
        route: "myinfo/api/v2/info",
    };
    GetPersonData.Domain = GetPersonDataDomain;
    GetPersonData.Transformers = GetPersonDataTransformer;
})(GetPersonData || (exports.GetPersonData = GetPersonData = {}));
var GetInfoPreferencesV2;
(function (GetInfoPreferencesV2) {
    GetInfoPreferencesV2.method = "GET";
    GetInfoPreferencesV2.route = "myinfo/api/v2/info-preferences";
    GetInfoPreferencesV2.Domain = getInfoPreferencesV2Domain;
    GetInfoPreferencesV2.Transformers = getInfoPreferencesV2Transformer;
})(GetInfoPreferencesV2 || (exports.GetInfoPreferencesV2 = GetInfoPreferencesV2 = {}));
var GetPersonSensitiveData;
(function (GetPersonSensitiveData) {
    GetPersonSensitiveData.method = "GET";
    GetPersonSensitiveData.route = "myinfo/api/v1/info-sensitive";
    GetPersonSensitiveData.Domain = getSenstivePersonDataDomain;
    GetPersonSensitiveData.Transformers = getSenstivePersonDataTransformer;
})(GetPersonSensitiveData || (exports.GetPersonSensitiveData = GetPersonSensitiveData = {}));
var SavePersonSensitiveData;
(function (SavePersonSensitiveData) {
    SavePersonSensitiveData.method = "POST";
    SavePersonSensitiveData.route = "myinfo/api/v1/info-sensitive";
    SavePersonSensitiveData.Domain = saveSenstivePersonDataDomain;
    SavePersonSensitiveData.Transformers = saveSenstivePersonDataTransformer;
})(SavePersonSensitiveData || (exports.SavePersonSensitiveData = SavePersonSensitiveData = {}));
var RefreshPersonSensitiveData;
(function (RefreshPersonSensitiveData) {
    RefreshPersonSensitiveData.method = "PUT";
    RefreshPersonSensitiveData.route = "myinfo/api/v1/info-sensitive";
    RefreshPersonSensitiveData.Domain = refreshSenstivePersonDataDomain;
    RefreshPersonSensitiveData.Transformers = refreshSenstivePersonDataTransformer;
})(RefreshPersonSensitiveData || (exports.RefreshPersonSensitiveData = RefreshPersonSensitiveData = {}));
var GetUinfinUserIdMapping;
(function (GetUinfinUserIdMapping) {
    GetUinfinUserIdMapping.method = "POST";
    GetUinfinUserIdMapping.route = "myinfo/api/v1/getUinfinUserIdMapping";
    GetUinfinUserIdMapping.Domain = getUinfinUserIdMappingDomain;
    GetUinfinUserIdMapping.Transformers = getUinfinUserIdMappingTransformer;
})(GetUinfinUserIdMapping || (exports.GetUinfinUserIdMapping = GetUinfinUserIdMapping = {}));
var GetHashedUinfin;
(function (GetHashedUinfin) {
    GetHashedUinfin.method = "GET";
    GetHashedUinfin.route = "myinfo/api/v1/getHashedUinfin";
    GetHashedUinfin.Domain = getHashedUinfinDomain;
    GetHashedUinfin.Transformers = getHashedUinfinTransformer;
})(GetHashedUinfin || (exports.GetHashedUinfin = GetHashedUinfin = {}));
var GetMyHashedUinfin;
(function (GetMyHashedUinfin) {
    GetMyHashedUinfin.method = "GET";
    GetMyHashedUinfin.route = "myinfo/api/v1/getMyHashedUinfin";
    GetMyHashedUinfin.Domain = getMyHashedUinfinDomain;
    GetMyHashedUinfin.Transformers = getMyHashedUinfinTransformer;
})(GetMyHashedUinfin || (exports.GetMyHashedUinfin = GetMyHashedUinfin = {}));
var GetHashedUinfinUserIdMapping;
(function (GetHashedUinfinUserIdMapping) {
    GetHashedUinfinUserIdMapping.method = "POST";
    GetHashedUinfinUserIdMapping.route = "myinfo/api/v1/getHashedUinfinUserIdMapping";
    GetHashedUinfinUserIdMapping.Domain = getHashedUinfinUserIdMappingDomain;
    GetHashedUinfinUserIdMapping.Transformers = getHashedUinfinUserIdMappingTransformer;
})(GetHashedUinfinUserIdMapping || (exports.GetHashedUinfinUserIdMapping = GetHashedUinfinUserIdMapping = {}));
var GetHashUinfinsFromUserIds;
(function (GetHashUinfinsFromUserIds) {
    GetHashUinfinsFromUserIds.method = "POST";
    GetHashUinfinsFromUserIds.route = "myinfo/api/v1/getHashedUinfinsFromUserIds";
    GetHashUinfinsFromUserIds.Domain = getHashedUinfinsFromUserIdsDomain;
    GetHashUinfinsFromUserIds.Transformers = getHashedUinfinsFromUserIdsTransformer;
})(GetHashUinfinsFromUserIds || (exports.GetHashUinfinsFromUserIds = GetHashUinfinsFromUserIds = {}));
var GetWogUserProfile;
(function (GetWogUserProfile) {
    GetWogUserProfile.method = "GET";
    GetWogUserProfile.route = "myinfo/api/v1/wog-users/myprofile";
    GetWogUserProfile.Domain = getWogUserProfileApiDomain;
    GetWogUserProfile.Transformers = getWogUserProfileTransformer;
})(GetWogUserProfile || (exports.GetWogUserProfile = GetWogUserProfile = {}));
var CreateUserIdentifier;
(function (CreateUserIdentifier) {
    CreateUserIdentifier.method = "POST";
    CreateUserIdentifier.route = (uid) => `myinfo/api/v1/wog-users/${uid}/identifiers`;
    CreateUserIdentifier.Domain = createUserIdentifierApiDomain;
    CreateUserIdentifier.Transformers = createUserIdentifierTransformer;
})(CreateUserIdentifier || (exports.CreateUserIdentifier = CreateUserIdentifier = {}));
var CreateWogUser;
(function (CreateWogUser) {
    CreateWogUser.method = "POST";
    CreateWogUser.route = "myinfo/api/v1/wog-users";
    CreateWogUser.Domain = createWogUserApiDomain;
    CreateWogUser.Transformers = createWogUserTransformer;
})(CreateWogUser || (exports.CreateWogUser = CreateWogUser = {}));
var GetWogUserData;
(function (GetWogUserData) {
    GetWogUserData.method = "GET";
    GetWogUserData.route = "myinfo/api/v1/wog-users";
    GetWogUserData.Domain = getWogUserApiDomain;
    GetWogUserData.Transformers = getWogUserTransformer;
})(GetWogUserData || (exports.GetWogUserData = GetWogUserData = {}));
var GetWogUserDataByIdentifiers;
(function (GetWogUserDataByIdentifiers) {
    GetWogUserDataByIdentifiers.method = "POST";
    GetWogUserDataByIdentifiers.route = "myinfo/api/v1/wog-users/identifiers";
    GetWogUserDataByIdentifiers.Domain = getWogUsersByIdentifierApiDomain;
    GetWogUserDataByIdentifiers.Transformers = getWogUsersByIdentifierTransformer;
})(GetWogUserDataByIdentifiers || (exports.GetWogUserDataByIdentifiers = GetWogUserDataByIdentifiers = {}));
var GetUserIdentifierData;
(function (GetUserIdentifierData) {
    GetUserIdentifierData.method = "GET";
    GetUserIdentifierData.route = (uid) => `myinfo/api/v1/wog-users/${uid}/identifiers`;
    GetUserIdentifierData.Domain = getUserIdentifierApiDomain;
    GetUserIdentifierData.Transformers = getUserIdentifierTransformer;
})(GetUserIdentifierData || (exports.GetUserIdentifierData = GetUserIdentifierData = {}));
var UpsertWogUsersData;
(function (UpsertWogUsersData) {
    UpsertWogUsersData.method = "PUT";
    UpsertWogUsersData.route = (uid) => `myinfo/api/v1/wog-users/${uid}`;
    UpsertWogUsersData.Domain = upsertWogUserApiDomain;
    UpsertWogUsersData.Transformers = upsertWogUserTransformer;
})(UpsertWogUsersData || (exports.UpsertWogUsersData = UpsertWogUsersData = {}));
var UpdateUserIdentifierData;
(function (UpdateUserIdentifierData) {
    UpdateUserIdentifierData.method = "PUT";
    UpdateUserIdentifierData.route = (uid, id) => `myinfo/api/v1/wog-users/${uid}/identifiers/${id}`;
    UpdateUserIdentifierData.Domain = updateUserIdentifierApiDomain;
    UpdateUserIdentifierData.Transformers = updateUserIdentifierTransformer;
})(UpdateUserIdentifierData || (exports.UpdateUserIdentifierData = UpdateUserIdentifierData = {}));
var GetGuestUser;
(function (GetGuestUser) {
    GetGuestUser.method = "GET";
    GetGuestUser.route = "myinfo/api/v1/guest";
    GetGuestUser.Domain = getGuestUserApiDomain;
})(GetGuestUser || (exports.GetGuestUser = GetGuestUser = {}));
var GetUserIdsByPostals;
(function (GetUserIdsByPostals) {
    GetUserIdsByPostals.method = "GET";
    GetUserIdsByPostals.route = "myinfo/api/v1/getUserIdsByPostals";
    GetUserIdsByPostals.Domain = getUserIdsByPostals;
    GetUserIdsByPostals.Transformers = getUserIdsByPostalsTransformer;
})(GetUserIdsByPostals || (exports.GetUserIdsByPostals = GetUserIdsByPostals = {}));
var GetUnifiedUserProfile;
(function (GetUnifiedUserProfile) {
    GetUnifiedUserProfile.method = "GET";
    GetUnifiedUserProfile.route = "myinfo/api/v1/unified/me";
    GetUnifiedUserProfile.Domain = getUnifiedUserApiDomain;
})(GetUnifiedUserProfile || (exports.GetUnifiedUserProfile = GetUnifiedUserProfile = {}));
var CreateSsoUser;
(function (CreateSsoUser) {
    CreateSsoUser.method = "POST";
    CreateSsoUser.route = "myinfo/api/v1/sso-users";
    CreateSsoUser.Domain = createSsoUserApiDomain;
    CreateSsoUser.Transformers = createSsoUserTransformer;
})(CreateSsoUser || (exports.CreateSsoUser = CreateSsoUser = {}));
var GetSsoUserData;
(function (GetSsoUserData) {
    GetSsoUserData.method = "GET";
    GetSsoUserData.route = "myinfo/api/v1/sso-users";
    GetSsoUserData.Domain = getSsoUserApiDomain;
    GetSsoUserData.Transformers = getSsoUserTransformer;
})(GetSsoUserData || (exports.GetSsoUserData = GetSsoUserData = {}));
var UpsertSsoUsersData;
(function (UpsertSsoUsersData) {
    UpsertSsoUsersData.method = "PUT";
    UpsertSsoUsersData.route = (uid) => `myinfo/api/v1/sso-users/${uid}`;
    UpsertSsoUsersData.Domain = upsertSsoUserApiDomain;
    UpsertSsoUsersData.Transformers = upsertSsoUserTransformer;
})(UpsertSsoUsersData || (exports.UpsertSsoUsersData = UpsertSsoUsersData = {}));
var GetMobileOtpData;
(function (GetMobileOtpData) {
    GetMobileOtpData.method = "GET";
    GetMobileOtpData.route = (uid) => `myinfo/api/v1/mobile-otp/${uid}`;
    GetMobileOtpData.Domain = getMobileOtpApiDomain;
})(GetMobileOtpData || (exports.GetMobileOtpData = GetMobileOtpData = {}));
var UpsertMobileOtpData;
(function (UpsertMobileOtpData) {
    UpsertMobileOtpData.method = "PATCH";
    UpsertMobileOtpData.route = () => `myinfo/api/v1/mobile-otp`;
    UpsertMobileOtpData.Domain = upsertMobileOtpApiDomain;
    UpsertMobileOtpData.Transformers = upsertMobileOtpTransformer;
})(UpsertMobileOtpData || (exports.UpsertMobileOtpData = UpsertMobileOtpData = {}));
var FindOrCreateUser;
(function (FindOrCreateUser) {
    FindOrCreateUser.method = "POST";
    FindOrCreateUser.route = "myinfo/api/v1/user";
    FindOrCreateUser.Domain = findOrCreateUserApiDomain;
})(FindOrCreateUser || (exports.FindOrCreateUser = FindOrCreateUser = {}));
var BulkRetrieveHashedUinfin;
(function (BulkRetrieveHashedUinfin) {
    BulkRetrieveHashedUinfin.method = "POST";
    BulkRetrieveHashedUinfin.route = "myinfo/api/v1/bulkRetrieveHashedUinfinForService";
    BulkRetrieveHashedUinfin.Domain = bulkRetrieveHashedUinfinApiDomain;
    BulkRetrieveHashedUinfin.Transformers = bulkRetrieveHashedUinfinTransformer;
})(BulkRetrieveHashedUinfin || (exports.BulkRetrieveHashedUinfin = BulkRetrieveHashedUinfin = {}));
//# sourceMappingURL=index.js.map